import { incYenOf, incOf } from '../lib/pricing';
export const chauffeurHero = {
  title: 'ハイヤー・送迎向け 法人研修',
  titleEn: 'FOR CHAUFFEUR & VIP TRANSPORT',
  lead: '乗降の所作と車内の気配りを、執事のもてなしに基づくビジネスマナー研修で磨くプログラムです。',
};

export const chauffeurTrustBadges = [
  {
    icon: 'ri-steering-line',
    text: '乗降・ドアサービスの所作を統一',
  },
  {
    icon: 'ri-map-pin-user-line',
    text: '出張型で貴社の営業所・研修室へ',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const chauffeurPainPoints = [
  {
    icon: 'ri-user-voice-line',
    text: '運転技術は高いが、乗降の所作やお声がけにばらつきがある',
  },
  {
    icon: 'ri-lock-line',
    text: '役員・VIP送迎で求められる距離感と守秘を体系的に教えられていない',
  },
  {
    icon: 'ri-briefcase-line',
    text: '手荷物の扱いやドアサービスの作法が個人任せ',
  },
  {
    icon: 'ri-flight-land-line',
    text: '空港送迎・接待送迎での待機・お出迎えの品格を上げたい',
  },
];

export const chauffeurWhy = [
  {
    icon: 'ri-car-line',
    title: '執事の所作とショーファーサービスの本質的な一致',
    description:
      '執事はもともと、主の移動に付き添い、ドアの開閉、手荷物の取り扱い、車中の気配りを担ってきました。これはショーファーサービスが求める所作と本質的に同じであり、全業種の中で最も親和性が高い領域です。本研修では、執事が体系化してきた「移動のもてなしの型」を、現場で再現できる形でお伝えします。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '守秘と距離感を技術として教えられる',
    description:
      'ハイヤー・送迎の現場では、乗車される方との適切な距離感と守秘が不可欠です。「親しみ」と「踏み込みすぎない品格」の線引きは、経験則に頼りがちですが、執事の接遇理論では明確な基準として言語化されています。本研修では、会話の切り出し方から沈黙の許容まで、具体的な技術として指導します。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '車という限られた空間での気配りを実技で磨く',
    description:
      '車内という閉じられた空間では、温度・音・香り・会話のひとつひとつが乗り心地を左右します。座学ではなく実技中心の訓練を通じて、受講者の身体に「先回りの気配り」を染み込ませます。研修翌日から、お客様に「いつもと違う」と言われる接遇品質を目指します。',
  },
];

export const chauffeurPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い・身だしなみ）＋ M2（VIP対応の原則・守秘）',
    description:
      '送迎の現場でまず整えるべき「立ち居振る舞い」と「VIP対応の原則」を半日で集中的に学ぶ短期プランです。まずは試行的に導入したい場合や、特定の課題に絞ったブラッシュアップに適しています。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2 ＋ M3（乗降・手荷物の所作実技）＋ M4（想定外対応ロールプレイング）',
    description:
      '立ち居振る舞いからVIP対応の原則、乗降の実技、想定外対応のロールプレイングまで、ショーファーサービスの接遇基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: '継続プログラム',
    duration: '月1半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    modules: '新人ドライバーの定着研修に推奨／毎月テーマを変えて段階的に習得',
    description:
      '新たに加わるドライバーに、月1回の研修を通じて接遇の型を段階的に定着させるプログラムです。単発研修では残りにくい所作も、反復と現場フィードバックのサイクルで確実に身につきます。',
  },
];

export const chauffeurScenarios = [
  {
    number: '01',
    title: '車寄せでのお出迎えと乗車',
    description:
      '車寄せでの停車位置とタイミング、後部ドアの開閉所作、手荷物の預かり方とトランクへの収納所作、乗車時の一言と目線の配り方、傘の差し出し方まで、一連の所作を反復練習します。お客様が最初に感じる「迎え入れの質」に重点を置き、所作の一つひとつに意味と品格を宿らせる技術を習得します。',
    imageSeq: 'chauffeur-scenario-1',
  },
  {
    number: '02',
    title: '車内での気配り',
    description:
      '温度・音・香りの先回り確認、会話の切り出し方と距離感、沈黙の許容とタイミング、乗客の酔いや体調への配慮、降車時のタイミングとお声がけまで、車内という限られた空間での気配りを訓練します。特に役員・VIP送迎で求められる「察する力」を、具体的なチェックリストとロールプレイングで磨きます。',
    imageSeq: 'chauffeur-scenario-2',
  },
  {
    number: '03',
    title: '空港・接待送迎',
    description:
      'フライト遅延時の待機の品格と情報収集、複数名のお出迎え時の優先順位と動線、同伴者・お子様への配慮、手荷物の数が多い場合の捌き方、到着ロビーから車両までのご案内所作までをロールプレイングで訓練します。不測の事態にも慌てず対応できる「型」を身につけます。',
    imageSeq: 'chauffeur-scenario-3',
  },
];

export const chauffeurTargetRoles = [
  'ハイヤー・専属ドライバー',
  '役員・VIP送迎担当',
  '空港送迎担当',
  '運行管理者',
  '新人教育担当',
];

export const chauffeurPricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '継続プログラム',
    duration: '月1半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '新人定着研修に推奨',
  },
];

export const chauffeurPricingConditions = {
  dispatch: '出張時の交通費・宿泊費は実費別途',
  capacity: '推奨12名まで（超過は2班制等をご提案）',
  vehicle: '実車を用いた実技は貴社車両を使用します。会場と車両の条件をヒアリング時にお知らせください。',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const chauffeurFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '対象人数・課題・希望時期・車両台数などをオンラインまたはお電話で伺います。',
  },
  {
    step: '03',
    title: '提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴社の運行形態に最適な研修プログラムとお見積りをご提案します。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では貴社の営業所・研修室で実車を用いた実技訓練を行います。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const chauffeurCategoryOptions = [
  { value: '', label: '選択してください' },
  { value: 'hire-car', label: 'ハイヤー' },
  { value: 'executive', label: '役員送迎' },
  { value: 'airport', label: '空港送迎' },
  { value: 'dedicated', label: '専属ドライバー' },
  { value: 'other', label: 'その他' },
];

export const chauffeurFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const chauffeurFaqs = [
  {
    question: '執事の資格が取れますか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修で、資格付与はありません。受講証（参加証明）を発行できます。',
  },
  {
    question: '実車での実技はできますか？',
    answer:
      'はい。貴社車両を用いた乗降・ドアサービスの実技に対応します。',
  },
  {
    question: '運転技術の指導もありますか？',
    answer:
      'いいえ。本研修は接遇・所作・ビジネスマナーに特化し、運転技能の指導は行いません。',
  },
];

export const chauffeurRelatedPages = [
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験・イベントのおもてなしを高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ホテル・旅館',
    description: '開業前研修からバトラーサービスの型まで',
    href: '/corporate/hotel',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層対応の信頼を所作から築く',
    href: '/corporate/finance',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
];